import { Link } from 'react-router-dom';
import logoUtiNeo from '../../../img/logoUtiNeo.png';
import logoUnimed from '../../../img/logo_Unimed Sudoeste de Minas-1.png';

import MenuPages from './menuPages';

const Navbar = () => {
    return (
        <nav
            className="navbar navbar-expand-lg navbar-light bg-white px-3 px-lg-4 py-3 py-lg-0 w-100 d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center">
                <img src={logoUtiNeo} alt="Logo" style={{ width: 70 }} />
                <Link to="/index" className="navbar-brand p-0 ms-2">
                    <h1 className="text-primary m-0 ms-2 fontUnimed">UTI Neonatal</h1>
                </Link>
            </div>
            <div className="position-absolute start-50 translate-middle-x d-none d-lg-block">
                <img src={logoUnimed} alt="Logo" style={{ width: 150 }} />
            </div>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
                <span className="fa fa-bars"></span>
            </button>

            <MenuPages />

        </nav>
    )
};

export default Navbar;